/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'at.markpub.facets.baseBlocks'

type $nsid = typeof $nsid

export { $nsid }

type Main = {
  $type?: 'at.markpub.facets.baseBlocks'
  index: ByteSlice
  features: (
    | l.$Typed<HorizontalRule>
    | l.$Typed<YamlFrontMatter>
    | l.$Typed<Raw>
    | l.Unknown$TypedObject
  )[]
}

export type { Main }

const main = /*#__PURE__*/ l.typedObject<Main>(
  $nsid,
  'main',
  /*#__PURE__*/ l.object({
    index: /*#__PURE__*/ l.ref<ByteSlice>((() => byteSlice) as any),
    features: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<HorizontalRule>(
            (() => horizontalRule) as any,
          ),
          /*#__PURE__*/ l.typedRef<YamlFrontMatter>(
            (() => yamlFrontMatter) as any,
          ),
          /*#__PURE__*/ l.typedRef<Raw>((() => raw) as any),
        ],
        false,
      ),
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

/** Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets. Byte slices can overlap. */
type ByteSlice = {
  $type?: 'at.markpub.facets.baseBlocks#byteSlice'
  byteStart: number
  byteEnd: number
}

export type { ByteSlice }

/** Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets. Byte slices can overlap. */
const byteSlice = /*#__PURE__*/ l.typedObject<ByteSlice>(
  $nsid,
  'byteSlice',
  /*#__PURE__*/ l.object({
    byteStart: /*#__PURE__*/ l.integer({ minimum: 0 }),
    byteEnd: /*#__PURE__*/ l.integer({ minimum: 0 }),
  }),
)

export { byteSlice }

/** Place an `&lt;hr&gt;` element at the provided byte index. */
type HorizontalRule = { $type?: 'at.markpub.facets.baseBlocks#horizontalRule' }

export type { HorizontalRule }

/** Place an `&lt;hr&gt;` element at the provided byte index. */
const horizontalRule = /*#__PURE__*/ l.typedObject<HorizontalRule>(
  $nsid,
  'horizontalRule',
  /*#__PURE__*/ l.object({}),
)

export { horizontalRule }

/** Identify a block of front matter at the top of the Markdown block. It is expected that this has a byteStart and byteEnd. */
type YamlFrontMatter = {
  $type?: 'at.markpub.facets.baseBlocks#yamlFrontMatter'
}

export type { YamlFrontMatter }

/** Identify a block of front matter at the top of the Markdown block. It is expected that this has a byteStart and byteEnd. */
const yamlFrontMatter = /*#__PURE__*/ l.typedObject<YamlFrontMatter>(
  $nsid,
  'yamlFrontMatter',
  /*#__PURE__*/ l.object({}),
)

export { yamlFrontMatter }

/** Place raw text at the provided byte index. This is a powerful escape hatch for anything that can't be achieved with the other facet features, but use it with caution as it can easily break things if used incorrectly. Do not expect systems to render it. */
type Raw = { $type?: 'at.markpub.facets.baseBlocks#raw' }

export type { Raw }

/** Place raw text at the provided byte index. This is a powerful escape hatch for anything that can't be achieved with the other facet features, but use it with caution as it can easily break things if used incorrectly. Do not expect systems to render it. */
const raw = /*#__PURE__*/ l.typedObject<Raw>(
  $nsid,
  'raw',
  /*#__PURE__*/ l.object({}),
)

export { raw }
